import { lazy } from 'lib/retry';

export const TextDocument = lazy(async () => import('./index'), 'TextDocument');
